import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import {ReactComponent as SearchIcon} from "../../assets/search.svg";


const CustomInput = styled.input`
    width: 300px;
    height: 32px;

    background-color: #FFFFFF;
    /* default/gray/400 */
    border: 1px var(--color-gray-400);
    border-style: solid none solid solid;
    box-sizing: border-box;
    border-radius: 4px 0px 0px 4px;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */
    
    /* default/gray/500 */
    //color: #A0AEC0;
    
    &::placeholder {
      color: var(--font-secondary);
    }
    
    &:focus {
      outline: none;
      //box-shadow: var(--focus);
    }
    
    &:focus-within {
      //outline: none;   
    }
    
    &:active {
      //outline: none;
    }
    text-indent: var(--space-s);
    //margin: 20px 0 20px var(--space-s1);
`;

const CustomButton = styled.button`
    width: 52px;
    height: 32px;
    
        /* default/gray/700 */
    background: #4E5664;
    border-radius: 0 4px 4px 0;
    //border: 1px var(--color-gray-400);
    border-style: none;
    
    &:focus {
      outline: none;
    }
    
    &:active, &:focus {
      border-color: var(--focus);
    }
`;

const ComponentWrapper = styled.div`
    display: flex;
    align-items: center;
`;

function CustomSearchField(props) {

    const {placeholder, onSearchChange, onSearchClick, value} = props;

        return (
        <ComponentWrapper>
            <CustomInput type="text" value={value} placeholder={placeholder} onChange={onSearchChange}/>
            <CustomButton onClick={onSearchClick}><SearchIcon/></CustomButton>
        </ComponentWrapper>
    );
}

CustomSearchField.propTypes = {
    placeholder: PropTypes.string,
    onSearchChange: PropTypes.func,
    onSearchClick: PropTypes.func.isRequired,
    value: PropTypes.string
};
CustomSearchField.defaultProps = {};

export default CustomSearchField;
